import React from 'react';
import './PageSplit.css';

/**
 * Baustein 9 — PageSplit.
 * Zwei-Spalten-Layout: Haupt-Inhalt links (flex), Sidebar rechts (fest 320px).
 * Für Pages mit Detail-Sidebar (Wantlist) oder side-by-side Sections (Lobby).
 * Unter 900px wird das Layout einspaltig; enthält die Sidebar ein
 * `DetailSidePanel`, bekommt der Container zusätzlich unten Scroll-Puffer,
 * damit die letzten Zeilen des Haupt-Inhalts hinter dem zum Bottom-Sheet
 * gewordenen Panel erreichbar bleiben.
 *
 * Verwendung (innerhalb einer Page):
 *   <PageSplit>
 *     <main>...Haupt-Inhalt...</main>
 *     <aside>...Sidebar...</aside>
 *   </PageSplit>
 *
 * Mehrere Children sind erlaubt, aber das Grid hat nur zwei Spalten —
 * zusätzliche Kinder fließen in eine neue Zeile in Spalte 1.
 */
export default function PageSplit({ children }) {
  return <div className="page-split">{children}</div>;
}
